// ECharts draws text itself, so it cannot inherit the CSS font variables from the P360 root.
export const PARTNER360_CHART_FONT_FAMILY = 'Forma DJR UI, sans-serif'
